let arr=document.cookie.split(";");
let obj={};
for(let i=0;i<arr.length;i++){
  arr[i]=arr[i].replace(/(^\s*) | (\s*$)/g,"");
  obj[arr[i].split("=")[0]]=arr[i].split("=")[1];
}

import Vue from 'vue';
import VueX from 'vuex';
import cookies from 'js-cookie';
import createPersistedState from "vuex-persistedstate"
import getters from './getters'
import dbs from './modules/dbs'
import commits from './modules/commits'
import settings from './modules/settings'
import orders from './modules/orders'
Vue.use(VueX);

// import '../../static/config.js';
export default new VueX.Store({
  state:{
    // port:"http://localhost:9000",
    // imgUrl:"http://localhost:9000",
    port:"https://tismo.pku-genomics.org/tismo",
    rport:"https://tismo.pku-genomics.org/rtismo",
    imgUrl:"https://tismo.pku-genomics.org/img/",
    // port:"https://15.165.121.172/tismo",
    // rport:"https://15.165.121.172/rtismo",
    // imgUrl:"https://15.165.121.172/img/",

    // port:"http://localhost:9001/tismo",
    // rport:"http://localhost:9008/rtismo",
    // imgUrl:"http://localhost:80/img/",

    system_name_cn:systemConfig.system_name_cn,
    system_name_en:systemConfig.system_name_en,
    advertiser_id:"1",
    // advertiser_id:obj["advertiser_id"],
    isLoading:true,
    userName:localStorage.getItem("userName") || "",
    zoneCode:"",
    doError:false,//操作提示框
    errorAlert:false,//操作提示框
    nodeId:localStorage.getItem("nodeId") || "",
    userType:localStorage.getItem("userType") || "",
    didNum:localStorage.getItem("didNum") || "",
    deviceId:localStorage.getItem("deviceId") || "",
    deviceName:localStorage.getItem("deviceName") || "",
    isLoad:false,//是否登录
    id:0,
  },
  mutations:{
    setName(state,msg) {
      state.advertiser_id = msg;
    },
    setDoError(state,doError) {
      state.doError = doError;
    },
    setErrorAlert(state,errorAlert) {
      state.errorAlert = errorAlert;
    },
    setStatus(state,status){
      state.isLoading=status;
    },
    setUserName(state,userName){
      state.userName=userName;
    },
    setNodeId(state,nodeId){
      state.nodeId=nodeId;
    },
    setUserType(state,userType){
      state.userType=userType;
    },
    setDeviceId(state,deviceId){
      state.deviceId=deviceId;
    },
    setDeviceName(state,deviceName){
      state.deviceName=deviceName;
    },
    setDidNum(state,didNum){
      state.didNum=didNum;
    },
    setIsLoad(state,isLoad){
      state.isLoad=isLoad;
    },
    hideLoading () {
      this.state.isLoading=false;
    }
  },
  modules: {
    dbs,
    commits,
    settings,
    orders,
  },
  getters,
  plugins: [
    createPersistedState()
  ]
});





// WEBPACK FOOTER //
// ./src/store/store.js